// extracted by mini-css-extract-plugin
export default {"sectionForm":"Form_sectionForm__yNgpR","container":"Form_container__WXj-7","form":"Form_form__e1yzW","formBtn":"Form_formBtn__u8Ete","error":"Form_error__Roa6G"};